import * as React from 'react';
import {useEffect, useState} from 'react';
import {Card, OverlayTrigger, Table, Tooltip} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Pagination} from '../../../shared/components/Pagination';
import {formatDate} from "../../../utils/Functions";
import {ImpersonateEye} from "../../../shared/components/ImpersonateEye";
import {FaCheck, FaTimes} from "react-icons/fa";
import {FiInfo} from "react-icons/all";
import {ContractService} from "../ContractService";
import {ContractFilter} from "./ContractFilter";
import {Contract} from "../../../model/contract/Contract";

export function ContractList() {
    const [contracts, setContracts] = useState<Contract[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [offersFilter, setState] = useState({
        page: 1,
        perPage: 15,
        id: "",
        date: "",
        influencerId: "",
        campaignId: "",
        status: ""
    })

    function getContract(offersFilter: any, updatePage?: number) {
        ContractService.getContracts({...offersFilter, page: !!updatePage ? updatePage: offersFilter.page})
            .then((data) => {
                setContracts(data?.data);
                setState({...offersFilter, page: data.page})
                setTotalPages(Math.ceil(data.count / offersFilter.perPage))
            })
            .catch((err) => {
                toast.error(`${err?.response?.data?.message}`)
            });
        }
        
    useEffect(() => {
        getContract(offersFilter);
    }, [offersFilter.campaignId, offersFilter.influencerId]);

    const handlePages = (updatePage: number) => {
        getContract(offersFilter, updatePage)
    };


    return (
        <>
            <Card className="mb-5 p-4"
                onKeyDown={(e: any) => {
                    if (e.key === "Enter") getContract(offersFilter);
                }}
            >
                <ContractFilter handleState={getContract} setState={setState} offersFilter={offersFilter}/>
            </Card>

            <Card className="mb-5 p-4">
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Contract ID</th>
                            <th>Company</th>
                            <th>Influencer</th>
                            <th>Campaign</th>
                            <th>Status</th>
                            <th>Agency?</th>
                            <th>Current?</th>
                            <th>Offers</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {contracts.map((e) => (
                        <tr key={e?.id}>
                            <td>{formatDate(e.createdAt)}</td>
                            <td>{e.id}</td>
                            <td>
                                <ImpersonateEye
                                    id={e?.campaign?.company?.createdBy}/>{e?.campaign?.company?.displayName}</td>
                            <td>
                                <ImpersonateEye
                                    id={e?.user?.id ?? 0}/>{e?.user?.displayName}<br/>{e?.user?.firstName ?? '-'} {e?.user?.lastName}
                            </td>
                            <td>{e?.campaign?.id}
                                <OverlayTrigger placement="top"
                                                overlay={<Tooltip
                                                    id="campaign-tooltip">
                                                    {e?.campaign?.title}
                                                </Tooltip>}>
                                    <FiInfo size={14} className="cursor-pointer ml-1"/>
                                </OverlayTrigger>
                            </td>
                            <td>
                                <span className={`status ${e?.status}`}>{e?.status}</span>
                            </td>
                            <td>
                                {e?.user?.agencyCompany?.id ? (
                                    e?.user?.agencyCompany?.id
                                ) : (
                                    <span className="word-break text-danger"><FaTimes/></span>
                                )}
                                {e?.user?.agencyCompany?.id && (
                                    <OverlayTrigger placement="top"
                                                    overlay={<Tooltip
                                                        id="campaign-tooltip">
                                                        {e?.user?.agencyCompany?.displayName}
                                                    </Tooltip>}>
                                        <FiInfo size={14} className="cursor-pointer ml-1"/>
                                    </OverlayTrigger>
                                )}
                            </td>
                            <td>
                                {e?.isCurrent ? (
                                    <span className="word-break text-primary"><FaCheck/></span>
                                ) : (
                                    <span className="word-break text-danger"><FaTimes/></span>
                                )}
                            </td>
                            <td>
                                {e?.offers?.length ?? 0}
                            </td>
                            <td>
                                <NavLink className="btn btn-primary" to={{
                                    pathname: '/contracts/edit',
                                    state: {id: e.id, offer: e}
                                }}>Edit</NavLink>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                <div className="w-100">
                    {totalPages > 1 &&
                        <Pagination
                            page={offersFilter.page}
                            totalPages={totalPages}
                            handlePagination={handlePages}
                        />
                    }
                </div>
            </Card>
        </>
    )
}
